import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Post } from "../../../utils/apiService";
import {
  CloseCancelEvacuationEventBody,
  IsEvacuationExistsBody,
  StartUpdateEvacuationBody,
  UpdateEvacuationEventParticipantStatusBody,
  UpdateEvacuationEventParticipantStatusByQRBody,
} from "../interface";
import { FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS } from "../query";

const isEvacuationExistsAction = async (body: IsEvacuationExistsBody) => {
  return Post({
    url: "/api/Evacuation/IsExists",
    body,
  });
};

export const useIsEvacuationExists = () => {
  return useMutation({
    mutationFn: async (body: IsEvacuationExistsBody) =>
      isEvacuationExistsAction(body),
  });
};

const startEvacuationAction = async (body: StartUpdateEvacuationBody) => {
  return Post({
    url: "/api/Evacuation/Start",
    body,
  });
};

export const useStartEvacuation = () => {
  return useMutation({
    mutationFn: async (body: StartUpdateEvacuationBody) =>
      startEvacuationAction(body),
  });
};

const updateEvacuationAction = async (body: StartUpdateEvacuationBody) => {
  return Post({
    url: "/api/Evacuation/Update",
    body,
  });
};

export const useUpdateEvacuation = () => {
  return useMutation({
    mutationFn: async (body: StartUpdateEvacuationBody) =>
      updateEvacuationAction(body),
  });
};

const closeEvacuationEventAction = async (
  body: CloseCancelEvacuationEventBody,
) => {
  return Post({
    url: "/api/Evacuation/Close",
    body,
  });
};

export const useCloseEvacuationEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CloseCancelEvacuationEventBody) =>
      closeEvacuationEventAction(body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_ALL_EVACUATION_EVENTS,
        ],
      });
    },
  });
};

const cancelEvacuationEventAction = async (
  body: CloseCancelEvacuationEventBody,
) => {
  return Post({
    url: "/api/Evacuation/Cancel",
    body,
  });
};

export const useCancelEvacuationEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CloseCancelEvacuationEventBody) =>
      cancelEvacuationEventAction(body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_ALL_EVACUATION_EVENTS,
        ],
      });
    },
  });
};

const UpdateEvacuationEventParticipantStatusAction = async (
  body: UpdateEvacuationEventParticipantStatusBody,
) => {
  return Post({
    url: "/api/EvacuationEvent/UpdateEvacuationStatus",
    body,
  });
};

export const useUpdateEvacuationEventParticipantStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateEvacuationEventParticipantStatusBody) =>
      UpdateEvacuationEventParticipantStatusAction(body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_ALL_EVACUATION_EVENT_PARTICIPANTS,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_EVACUATION_EVENT_PARTICIPANTS_COUNTS,
        ],
      });
    },
  });
};

const updateEvacuationEventParticipantStatusByQRAction = async (
  body: UpdateEvacuationEventParticipantStatusByQRBody,
) => {
  return Post({
    url: "/api/EvacuationEvent/UpdateEvacuationStatusForQR",
    body,
  });
};

export const useUpdateEvacuationEventParticipantStatusByQR = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateEvacuationEventParticipantStatusByQRBody) =>
      updateEvacuationEventParticipantStatusByQRAction(body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_ALL_EVACUATION_EVENT_PARTICIPANTS,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          FETCH_EMERGENCY_EVACUATION_DETAILS_KEYS.FETCH_EVACUATION_EVENT_PARTICIPANTS_COUNTS,
        ],
      });
    },
  });
};
